import { getCsrfToken } from "@/integrations/php/client";

export type StageReminderStatus = {
  enabled: boolean;
  activated_at: string | null;
  first_after_hours: number;
  final_after_hours: number;
  daily_send_time: string;
  eligible_leads: number;
  eligible_partners: number;
  first_reminders: number;
  final_reminders: number;
  updated_at: string | null;
  delivery?: {
    sent_items: number;
    cancelled_items: number;
    pending_items: number;
    partners_reached: number;
  };
  onboarding?: {
    invites_delivered: number;
    setup_requested: number;
    credentials_created: number;
    first_logins: number;
  };
};

const parseResponse = async (response: Response): Promise<StageReminderStatus> => {
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(body?.error?.message ?? "Η λειτουργία reminders δεν είναι διαθέσιμη.");
  return body.data as StageReminderStatus;
};

export const fetchStageReminderStatus = async (): Promise<StageReminderStatus> =>
  parseResponse(await fetch("/api/admin/stage-reminders.php", {
    credentials: "include",
    headers: { "X-CSRF-Token": await getCsrfToken() },
  }));

export const setStageReminderEnabled = async (enabled: boolean): Promise<StageReminderStatus> => {
  const csrfToken = await getCsrfToken();
  return parseResponse(await fetch("/api/admin/stage-reminders.php", {
    method: "PATCH",
    credentials: "include",
    headers: { "Content-Type": "application/json", "X-CSRF-Token": csrfToken },
    body: JSON.stringify(enabled
      ? { action: "enable", confirmation: "NEW_LEADS_ONLY" }
      : { action: "disable" }),
  }));
};
